import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Text, SvgIcon, Grid } from 'Components/Base';
import { FeedbackDisLike, FeedbackLike } from 'Containers/Feedback';

import FeedbackButton from '../Button/FeedbackButton';

const LikeButton = ({ onClickVideoEndingOverlayContent, ...props }) => {
  return (
    <Box width={'100%'} {...props}>
      <FeedbackButton
        onClick={onClickVideoEndingOverlayContent}
        title={'ชอบ'}
        icon={SvgIcon.ICON_LIST.LIKE}
        iconColor={'success'}
      />
    </Box>
  );
};

const DisLikeButton = ({ onClickVideoEndingOverlayContent, ...props }) => {
  return (
    <Box width={'100%'} {...props}>
      <FeedbackButton
        onClick={onClickVideoEndingOverlayContent}
        title={'ไม่ชอบ'}
        icon={SvgIcon.ICON_LIST.DISLIKE}
        iconColor={'danger'}
      />
    </Box>
  );
};

const FeedBackLayout = styled(Grid)`
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
`;

const FeedbackContent = ({ onClickVideoEndingOverlayContent }) => {
  return (
    <Box mt={1}>
      <Text textStyle={'body1Medium'} color={'text'} mb={4}>
        บอกความรู้สึกคลิปวิดีโอนี้กับเรา
      </Text>
      <FeedBackLayout gridGap={{ _: 2, sm: 4 }}>
        <FeedbackLike
          toggleComponent={
            <LikeButton onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent} />
          }
        />
        <FeedbackDisLike
          toggleComponent={
            <DisLikeButton onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent} />
          }
        />
      </FeedBackLayout>
    </Box>
  );
};

FeedbackContent.propTypes = {
  onClickVideoEndingOverlayContent: PropTypes.func,
};

LikeButton.propTypes = {
  onClickVideoEndingOverlayContent: PropTypes.func,
};

DisLikeButton.propTypes = {
  onClickVideoEndingOverlayContent: PropTypes.func,
};

export default FeedbackContent;
